import React from "react";
import { Trans } from "react-i18next";

import {
  Callout,
  FormGroup,
  HTMLSelect,
} from "@blueprintjs/core";
import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../../utils/AuthenticatedFetch";
import i18n from "../../../i18n";

function VehicleClassesSelect(props) {
  return (
    <FormGroup
      label={<Trans>matching</Trans>}
      inline={true}
      labelFor={"input_class" + props.default.id}
    >
      <HTMLSelect
        id={"input_class" + props.default.id}
        options={[
          { label: "default (" + i18n.t(props.default.label) + ")", value: 0 },
          ...props.classes,
        ].map((c) => {
          return { label: i18n.t(c.label), value: i18n.t(c.id) };
        })}
        onChange={(ti) => {
          if (props.onChange) props.onChange(ti.target.value || null);
        }}
        value={props.default.match || 0}
      />
    </FormGroup>
  );
}

export default function VehicleClasses() {
  const [vehicleclasses, setVehicleclasses] = React.useState([]);

  function update() {
    authenticatedGetFetch("/ow/dc/settings/vehicleclasses", (res) => {
      setVehicleclasses(res);
    });
  }

  React.useEffect(() => {
    update();
  }, []);

  return (
    <Callout title={<Trans>vehicle classes</Trans>}>
      {vehicleclasses.map((cl) => (
        <span key={"vc"+cl.id}>
          <Callout>
            <Trans>{cl.label}</Trans> ({cl.count} detections)
            <VehicleClassesSelect
              default={cl}
              classes={vehicleclasses}
              onChange={(match) => {
                authenticatedPostFetch(
                  "/ow/dc/settings/vehicleclass",
                  { ...cl, match: match },
                  () => {
                    update();
                  }
                );
              }}
            />
          </Callout>
          <br />
        </span>
      ))}
    </Callout>
  );
}
